const locale = {
  'productList.filter.title': 'التصفية',
  'productList.filter.reset': 'إعادة تعيين',
  'productList.filter.manufacturer': 'المصنع',
  'productList.filter.manufacturer.placeholder': 'اختيار السيارة',
  'productList.filter.years': 'السنوات',
  'productList.filter.years.start.placeholder': 'السنة البدائية',
  'productList.filter.years.end.placeholder': 'السنة النهائية',
  'productList.filter.models': 'أنواع السيارات',
  'productList.filter.models.placeholder': 'اختيار نوع السيارة',
  'productList.filter.bodycode': 'التكوين',
  'productList.filter.bodycode.placeholder': 'اختيار التكوين',
  'productList.filter.enginecode': 'الحجم المحرك',
  'productList.filter.enginecode.placeholder': 'اختيار الحجم المحرك',
  'productList.filter.catalogs': 'تصنيف الأجزاء',
  'productList.filter.catalogs.placeholder': 'اختيار التصنيف',

  'productList.message.addToListSuccessfully': 'تمت إضافة العنصر إلى القائمة بنجاح.',
  'productList.message.removingListSuccessfully': 'تمت إزالة العنصر من القائمة بنجاح.',
  'productList.message.addToListFailed': 'فشل في إضافة العنصر إلى القائمة.',
  'productList.message.removingListFailed': 'فشل في إزالة العنصر من القائمة.',

  'productList.loginGuidance.oeAndPrice':
    'يمكنك عرض الباقي من {total} عناصر OE والأسعار بعد تسجيل الدخول.',
  'productList.loginGuidance.price': 'يمكنك عرض الأسعار بعد تسجيل الدخول.',

  'productList.old': 'قديم',
  'productList.old.tips': 'هذا الرقم هو رقم قديم ولا يستخدمه الشركة المصنعة للسيارات حالياً.',
  'productList.replaceNum': 'رقم استبدال',
  'productList.replaceNum.OE': 'رقم OE',
  'productList.replaceNum.circulationRating': 'التقييم الدوري',
  'productList.replaceNum.price.OEM': 'سعر الشركة المصنعة للقطع الغيار الأصلية',
  'productList.replaceNum.price.aftermarket': 'سعر السوق التابع',
  'productList.replaceNum.suspensionDate': 'تاريخ الإيقاف',
  'productList.replaceNum.suspensionDate.tips':
    'تاريخ توقف الشركة المصنعة عن استخدام هذا الرقم. إذا كان التاريخ فارغاً، فهذا يشير إلى أن الشركة ما زالت تستخدم هذا الرقم.',
};

export default locale;
